import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Award, ArrowRight } from 'lucide-react';
import { Card } from '../ui/card';
import api from '../../lib/api';

// 'Verbinder van de week' — lichte sidebar-kaart, haalt zelf de huidige keuze op.
const VerbinderCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/community/verbinder-van-de-week')
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!data || !data.active) return null;
  const initials = (data.name || '?').split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();

  return (
    <Card className="p-5 bg-gradient-to-br from-hoi-coral/10 to-white border border-hoi-coral/20 shadow-soft" data-testid="verbinder-card">
      <h3 className="font-heading font-semibold text-sm text-gray-900 flex items-center gap-2 mb-3">
        <Award className="w-4 h-4 text-hoi-coral" aria-hidden="true" /> Verbinder van de week
      </h3>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-12 h-12 rounded-full bg-hoi-coral text-white flex items-center justify-center font-bold flex-shrink-0" aria-hidden="true">
          {initials}
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 leading-tight line-clamp-1" data-testid="verbinder-name">{data.name}</p>
          <p className="text-xs text-muted-foreground line-clamp-1">
            {data.wijk ? `${data.wijk} · ` : ''}{data.activity_count} {data.activity_count === 1 ? 'activiteit' : 'activiteiten'}
          </p>
        </div>
      </div>
      {data.blurb && <p className="text-sm text-gray-600 italic mb-3 leading-snug">“{data.blurb}”</p>}
      {data.activities && data.activities.length > 0 && (
        <div className="space-y-1.5">
          {data.activities.slice(0, 2).map((a) => (
            <Link key={a.id} to={`/activity/${a.id}`} className="flex items-center gap-2 text-sm text-gray-700 hover:text-hoi-coral transition-colors group" data-testid={`verbinder-activity-${a.id}`}>
              <ArrowRight className="w-3.5 h-3.5 flex-shrink-0 text-hoi-coral" />
              <span className="line-clamp-1 group-hover:underline">{a.title}</span>
            </Link>
          ))}
        </div>
      )}
    </Card>
  );
};

export default VerbinderCard;
